@if (label) {
  <div class="flex justify-between mb-2">
    <label class="block text-sm font-medium leading-6 text-fg-primary">{{ label }}</label>
    @if (isOptional) {
      <span class="text-sm leading-6 text-fg-secondary">Optional</span>
    }
  </div>
}
